import React, { useEffect, useState } from 'react';
import { authService } from '@/core/auth/export';
import { useEffectivePermissions } from '@/core/permissions/hooks/use-effective-permissions';

export default function RequirePermissions({
  allow,
  deny,
  children,
  fallback,
}: React.PropsWithChildren<{
  allow?: string | RegExp;
  deny?: string | RegExp;
  fallback?: JSX.Element;
}>) {
  const [ready, setReady] = useState(false);
  const permissions = useEffectivePermissions();

  useEffect(() => {
    authService.onTokenAvailable().then(() => setReady(true));
  }, []);

  if (!ready) return <></>;

  const allowMatching = permissions.reduce((accumulator, value) => {
    if (allow instanceof RegExp) {
      return allow.test(value) || accumulator;
    }

    return allow === value || accumulator;
  }, !allow);

  const denyMatching = permissions.reduce((accumulator, value) => {
    if (deny instanceof RegExp) {
      return deny.test(value) || accumulator;
    }

    return deny === value || accumulator;
  }, false);

  if (!denyMatching && allowMatching) return <>{children}</>;

  if (fallback) return fallback;

  return <></>;
}
